import styled from 'styled-components'

export const ObservationContainer = styled.div`
  background: #fff;
  border-radius: 2px;
  z-index: 100;
  position: fixed;
  width: 350px;
  max-height: 480px;
  padding: 7px;
  display: flex;
  flex-direction: column;
`

export const ObservationHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 5px 5px 8px;

  h2 {
    margin: 0;
    font-size: 1.1em;
  }
`

export const ObservationForm = styled.form`
  z-index: 100;
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 0 5px 5px;

  label {
    font-size: 0.8em;
    margin: 0;
  }
`

export const FieldBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`

export const TitleRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
`

export const DetailsButton = styled.button.attrs({ type: 'submit' })`
  margin-top: 4px;
  border-radius: 2px;
  border: 1px solid #073c7a;
  background: #fff;
  color: #073c7a;
  cursor: pointer;
  padding: 10px;
  text-align: center;
  width: 100%;
  font-size: 14px;

  &:disabled {
    cursor: default;
    color: #ccc;
    border: 1px solid #ccc;
  }
`

export const TitleInputWrap = styled.div`
  position: relative;
  width: 100%;
`

export const TitleInput = styled.input`
  width: 100%;
  padding: 10px;
  border: 1px solid #d4dbe8;
  box-sizing: border-box;
  font-size: 14px;
`

export const TitleSuggestions = styled.ul`
  position: absolute;
  left: 0;
  right: 0;
  top: 100%;
  margin: 0;
  padding: 0;
  list-style: none;
  background: #fff;
  border: 1px solid #d4dbe8;
  border-top: none;
  max-height: 160px;
  overflow: auto;
  z-index: 20;
`

export const TitleSuggestionItem = styled.li`
  padding: 8px 10px;
  cursor: pointer;
  font-size: 13px;

  &:hover {
    background: #eff6ff;
  }
`

export const NotesTextarea = styled.textarea`
  width: 100%;
  padding: 10px;
  border: 1px solid #d4dbe8;
  box-sizing: border-box;
  font-size: 14px;
  resize: vertical;
  min-height: 88px;
`

export const StatusChip = styled.button.attrs({ type: 'button' })<{
  $status: 'open' | 'closed'
}>`
  flex-shrink: 0;
  border: none;
  border-radius: 4px;
  padding: 4px 10px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  color: #0f172a;
  background: ${p => (p.$status === 'open' ? '#facc15' : '#4ade80')};

  &:hover {
    filter: brightness(0.95);
  }
`
